




























import { Employe } from "../../models/Employe";
import Planning = Employe.Planning;
import AddHourModal from "./AddHourModal.vue";
import PlanningWorkingHour = Employe.PlanningWorkingHour;
import { trimEnd } from "lodash";

export default {
    name: "PlanningModalEditDayHours",
    components: { AddHourModal },
    props: {
        day: Employe.EWorkingHourDay,
        planning: Planning,
    },
    data() {
        return {
            workingHours: [],
            addHourModal: false,
        };
    },
    created() {
        let self = this;
        if (self.planning.planning_working_hours.length > 0) {
            self.workingHours = _.chain(self.planning.planning_working_hours)
                .filter(function (workingHour) {
                    return workingHour.jour === self.day;
                })
                .value();
        }
    },
    methods: {
        addWorkingHour() {
            this.addHourModal = true;
        },
        closeHourModal(data) {
            this.addHourModal = false;
            if (data && data instanceof PlanningWorkingHour) {
                this.workingHours.push(data);
                this.sortHours();
            }
        },
        sortHours() {
            this.workingHours = _.sortBy(this.workingHours, "heure_debut");
        },
        deleteHour(workingHour) {
            this.workingHours = _.without(this.workingHours, workingHour);
        },
    },
    watch: {
        workingHours: {
            immediate: false,
            deep: true,
            handler: function () {
                let self = this;
                self.planning.planning_working_hours = _.chain(
                    self.planning.planning_working_hours
                )
                    .filter(function (workingHour) {
                        return workingHour.jour !== self.day;
                    })
                    .concat(self.workingHours)
                    .value();
            },
        },
    },
};
